import { Auth0Provider } from '@auth0/auth0-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  domain: string;
  clientId: string;
  audience?: string;
  children: ReactNode;
}

/**
 * Wraps Auth0Provider inside the React Router context so onRedirectCallback
 * can use navigate() rather than window.history.replaceState, which does not
 * notify React Router and causes it to render the wrong page.
 */
export function Auth0ProviderWithNavigate({ domain, clientId, audience, children }: Props) {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        ...(audience ? { audience } : {}),
        // Multi-tenant support: DO NOT set static organization parameter.
        // The org_id claim is included in the token based on the user's org membership.
      }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo ?? '/', { replace: true });
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
